import { Fragment } from 'react'
import { Box } from '@mui/material'
import { useApp } from '../hooks/useApp'
import { PageSubtitle } from '../components/atoms/PageSubtitle'
import { Trans, useTranslation } from 'react-i18next'
import { ChangePasswordForm } from '../components/forms/ChangePasswordForm'
import { ChangePasswordData } from '../types/auth'
import { callAxios } from '../hooks/useAxios'
import { TopTitle } from '../components/atoms/TopTitle'
import { SettingsForm } from '../components/forms/SettingsForm'
import { InstallerPasswordForm } from '../components/forms/InstallerPasswordForm'

export function SettingsPage(): React.ReactElement {

  const app = useApp()
  const { t } = useTranslation()

  const onSubmitPassword = (data: ChangePasswordData) => {
    callAxios({
      method: 'POST',
      url: '/auth/change-password',
    }, data).then(res => {
      if (res.success) {
        app.addInfo(t('Password change was successful.'))
      } else {
        app.addError(res)
      }
    })
  }

  return (
    <Fragment>
      <TopTitle title={t('Settings')}/>
      <Trans>Settings for</Trans> {app.user && app.user.email}

      <SettingsForm/>

      <PageSubtitle sx={{ mt: 7 }} title={t('Installer level')}/>
      <Box>
        <InstallerPasswordForm />
      </Box>

      <PageSubtitle sx={{ mt: 7 }} title={t('Change password')}/>
      <Box>
        <ChangePasswordForm onSubmit={onSubmitPassword}/>
      </Box>

    </Fragment>
  )
}
